<template>
	<div class="ring-chart" ref="chart"></div>
</template>

<script>
	import * as echarts from 'echarts';
	import apis from "@/http/apis";
	import chartClickMixin from "@/views/index/components/handlemixin.js"; // 引入点击事件
	export default {
		mixins: [chartClickMixin],
		name: 'StockAssetCategoryChart',
		data() {
			return {
				chart: null,
				unitMap: {}
			};
		},
		mounted() {
			this.initChart();
			this.fetchData();
		},
		beforeDestroy() {
			if (this.chart) {
				this.chart.dispose();
			}
		},
		methods: {
			initChart() {
				// 初始化图表
				this.chart = echarts.init(this.$refs.chart);

				// 图表配置
				const option = {
					// tooltip: {
					// 	trigger: 'item',
					// 	formatter: '{a} <br/>{b}: {c} ({d}%)'
					// },
					grid: {
						containLabel: true
					},
					legend: {
						bottom: '8',
						left: 'center',
						textStyle: {
							color: '#ffffff',
							fontSize: 10,
						},
						itemWidth: 10,
						itemHeight: 10,
						itemStyle: {
							borderWidth: 0
						},
						formatter: (name) => {
							return this.unitMap[name] ? `${name}(${this.unitMap[name]})` : name;
						}
					},
					series: [{
						name: '',
						type: 'pie',
						radius: ['28%', '40%'],
						center: ['50%', '38%'],
						avoidLabelOverlap: false,
						labelLayout: { hideOverlap: false },
						itemStyle: {
							borderRadius: 0,
							borderColor: '#fff',
							borderWidth: 0
						},
						label: {
							show: true,
							position: 'outside',
							formatter: (params) => {
								const unit = this.unitMap[params.name];
								const displayName = unit ? `${params.name}(${unit})` : params.name;
								return `{title|${displayName}}\n{value|${params.percent}%}`;
							},
							rich: {
								title: {
									fontSize: 10,
									color: '#fff',
									padding: [2, 0, 0, 0]
								},
								value: {
									fontSize: 10,
									color: '#fff',
									fontWeight: 'bold',
									padding: [2, 0, 0, 0]
								}
							}
						},
						emphasis: {
							label: {
								show: true,
								fontSize: 10,
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: true,
							length: 8,
							length2: 6,
							minTurnAngle: 0,
						},
						data: [{
								value: 0.35,
								name: '房产',
								itemStyle: {
									color: '#13c81c'
								}
							},
							{
								value: 0.25,
								name: '土地',
								itemStyle: {
									color: '#ff8a00'
								}
							},
							{
								value: 0.40,
								name: '房产及土地',
								itemStyle: {
									color: '#ffd600'
								}
							}
						]
					}]
				};

				// 设置选项并渲染
				this.chart.setOption(option);
	// 设置点击事件
				this.setupChartClick(this.chart, 'echarts');
				// 响应窗口大小变化
				window.addEventListener('resize', this.handleResize);
			},
			handleResize() {
				if (this.chart) {
					this.chart.resize();
				}
			},
			fetchData() {
				apis.stockAssetCategory()
					.then((res) => {
						const list = res && res.data && res.data.list ? res.data.list : [];
						const colors = ['#13c81c', '#ff8a00', '#ffd600'];
						const newUnitMap = {};
						list.forEach(item => { newUnitMap[item.type] = item.unit; });
						this.unitMap = newUnitMap;
						const newPieData = list.map((item, index) => ({
							value: item.ratio,
							name: item.type,
							itemStyle: { color: colors[index] || '#07e1ff' }
						}));
						if (this.chart && newPieData.length) {
							this.chart.setOption({ series: [{ data: newPieData }] });
						}
					})
					.catch((err) => {
						console.error('存量资产分类饼图接口请求失败', err);
					});
			}
		}
	};
</script>

<style scoped>
	.ring-chart {
		width: 100%;
		height: 90%;
		/* min-height: 300px; */
	}
</style>